module.exports = __webpack_public_path__ + "static/logo_dark-41998864f618dac4c32b4cec0a6241c5.png";